<button
  :class="{'btn':true, 'btn-block': block}"
  :type="type"
  :disabled="isDisabled"
>
  <font-awesome-icon
    v-if="icon"
    class="font-awesome-icon mr-2"
    :icon="['fab', icon]"
  />
  <slot />
  <div v-if="loading" class="spinner-border ml-2" role="status">
    <span class="sr-only">Carregando...</span>
  </div>
</button>
